module.exports = __webpack_public_path__ + "assets/img/Jem.ff4aa51e.jpg";